<template>
    <main v-if="visible" class="modal-overlay">
        <div class="modal-content-payment p-4">
            <button @click="closeModal" class="text-end w-full px-4">
                <i
                    class="pi pi-times text-red-500 bg-red-500/20 p-1 rounded-md"
                ></i>
            </button>
            <div class="flex flex-col md:flex-row">
                <section
                    class="md:flex-initial md:w-[25rem] space-y-4 flex flex-col justify-around px-2"
                >
                    <section class="space-y-2">
                        <span
                            class="hidden md:inline-flex text-xs text-gray-600 dark:text-gray-300"
                            >Você está aumentando suas quotas.</span
                        >
                        <h1
                            class="text-4xl font-black text-primary dark:text-primary-dark"
                        >
                            Shardfy
                        </h1>
                    </section>
                    <section>
                        <div class="flex flex-col gap-2">
                            <span class="flex items-center gap-2">
                                <i class="pi pi-check text-green-500"></i>
                                <span class="text-sm font-semibold"
                                    >Invista apenas no que você precisa.</span
                                >
                            </span>
                            <span
                                class="text-xs p-2 text-gray-600 dark:text-gray-300"
                            >
                                Sistema de pagamento por quota, com opções de
                                pagamento flexíveis e transparentes.
                            </span>
                        </div>
                        <span
                            class="text-xs block p-1 rounded-md font-semibold text-primary dark:text-primary-dark bg-primary/20 dark:bg-primary-dark/20"
                            >O valor total está incluindo com o seu plano atual
                            mais as quotas adicionais.</span
                        >
                    </section>
                    <section class="text-center md:text-start py-4">
                        <div class="py-4">
                            <span
                                class="text-xs font-semibold text-gray-600 dark:text-gray-300"
                                >Total de:
                            </span>
                            <p
                                class="text-4xl font-bold text-primary dark:text-primary"
                            >
                                R${{ amount }}<span class="text-xs">/mês</span>
                            </p>
                        </div>
                        <span
                            class="text-xs font-semibold p-1 rounded-md bg-gray-600/20 dark:bg-gray-300/20 text-gray-600 dark:text-gray-300"
                            >{{ remaining }}</span
                        >
                    </section>
                </section>
                <section
                    class="flex-1 flex gap-2 flex-col items-center justify-center"
                >
                    <img
                        :src="brCodeBase64"
                        alt="QrCode Pix"
                        class="rounded-md"
                    />
                    <!--Copy and paste -->
                    <span
                        class="text-xs font-semibold text-gray-600 dark:text-gray-300"
                        >Clique abaixo para copiar código pix</span
                    >
                    <div
                        class="relative w-[20rem] text-nowrap text-xs dark:bg-neutral-950 p-4 rounded-md overflow-clip group cursor-pointer hover:bg-primary/10 transition-colors"
                        @click="copyPixCode"
                        title="Clique para copiar"
                    >
                        <span>{{ brCode }}</span>
                        <i
                            class="pi pi-copy absolute right-1 p-2 top-2 bg-primary rounded-md"
                        ></i>
                    </div>
                    <!-- <button @click="handlePurchase">Comprar</button> -->
                </section>
            </div>
        </div>
    </main>
</template>

<script setup lang="ts">
import { toast } from "@/composables/useToast";
import { usePayment } from "@/composables/usePayment";
import paymenteStateRef from "@/composables/usePayment";
import { billingService } from "@/services/billing.service";
import confetti from "canvas-confetti";
import dayjs from "dayjs";
import { onMounted, onUnmounted, ref, watch } from "vue";
import utc from "dayjs/plugin/utc";

dayjs.extend(utc);

const paymentState = usePayment();
let interval: NodeJS.Timeout;
let intervalPayment: NodeJS.Timeout;
const remaining = ref("carregando...");
interface Props {
    visible: boolean;
    amount: number;
    brCode: string;
    expiresIn: string;
    brCodeBase64: string;
    paymentId: string;
}
const props = defineProps<Props>();
const update = () => {
    const expiresAt = dayjs.utc(props.expiresIn);
    const diff = expiresAt.diff(dayjs.utc(), "second");
    if (diff < 0) {
        remaining.value = "Expirado";
        clearInterval(interval);
        clearInterval(intervalPayment);
        closeModal();
        window.location.reload();
        return;
    }

    const minutes = Math.floor(diff / 60);
    const seconds = diff % 60;
    remaining.value = `${minutes}:${seconds.toString().padStart(2, "0")} minutos restantes`;
};

const verifyPayment = async () => {
    try {
        const response = await billingService.verifyPayment(props.paymentId);
        if (response.status === "PAID") {
            confetti({
                particleCount: 150,
                spread: 100,
                origin: { y: 0.6 },
            });
            remaining.value = "Pagamento realizado com sucesso";
            clearInterval(intervalPayment);
            clearInterval(interval);
            closeModal();
            window.location.reload();
        } else if (response.status === "EXPIRED") {
            clearInterval(intervalPayment);
            clearInterval(interval);
            closeModal();
            window.location.reload();
        }
    } catch (err) {
        console.error("Erro ao verificar pagamento:", err);
    }
};

const closeModal = () => {
    paymentState.closePaymentModal();
};

const copyPixCode = async () => {
    try {
        await navigator.clipboard.writeText(props.brCode);
        toast.success("Código PIX copiado com sucesso!");
    } catch (err) {
        console.error("Erro ao copiar código PIX:", err);
    }
};
watch(
    () => paymenteStateRef.value.isVisible,
    () => {
        if (paymenteStateRef.value.isVisible) {
            intervalPayment = setInterval(verifyPayment, 5000);
            interval = setInterval(update, 1000);
        } else {
            clearInterval(interval);
            clearInterval(intervalPayment);
        }
    },
);
onMounted(() => {});

onUnmounted(() => {
    clearInterval(interval);
});
</script>
